$(function () {
  $("#combinationsSingle_image-hero").fancybox();


  // setTimeout(function() {
  //   // Ustaw startową wartość w select po powrocie na strone
  //   $('[data-dlisting-filtrationbar]').find('select').each(function() {
  //     if ($(this).val('') !== '') {
  //       $(this).val('');
  //     }
  //   });
  // }, 100);
  

  $("[data-dlisting]:not(.initialized)").each((i, el) => new DynamicListingClass($(el)));

  // dodanie atrybutu role="list" dla list którym została dodana właściwość CSS list-style: none
  setAttribute(".pagination", "role", "list");
  setAttribute(".page-item", "aria-hidden", "true");
  setAttribute(".splide__slide", "role", "presentation");

  // skip link - fokus na wybrany element
  $("[data-skip-link]").on("keydown", function (e) {
    if (e.keyCode === 13) {
      const href = $(this).attr("href");
      const idElement = href.slice(1);
      document.getElementById(idElement).focus();
    }
  });

  // Add css scroll to element
  if ($(window).width() < 768) {
    if ($(".categories__big-list li").length > 4) {
      $(".categories__big-list").addClass("scrollMobile");
    }
  }

  //another way to check if there was cookie consent - in local storage
  checkIfCookieConsent();

  // SHOW OR HIDE CONTENT ON CLICK
  showHideContent();

  // Mega menu, newsletter - add class after loaded
  setTimeout(function () {
    $(".megaMenu, .newsletterForm").addClass("ready");
  }, 800);

  // Toggle show weather details
  $("[data-submit-tooltip]").on("click", function (e) {
    e.preventDefault();

    if ($(this).parent().hasClass("isVisible")) {
      $(this).parent().removeClass("isVisible");
      $(this).attr("aria-expanded", "false");
      $(this).parent().find("[data-content-tooltip]").fadeOut();
    } else {
      $(this).parent().addClass("isVisible");
      $(this).removeClass("isVisible").find("[data-content-tooltip]").fadeOut();
      $(this).attr("aria-expanded", "true");
      $(this)
        .parent()
        .addClass("isVisible")
        .find("[data-content-tooltip]")
        .fadeIn();

      trapFocus("#weatherTooltip");
    }
  });

  $("[data-close-tooltip]").on("click", function () {
    $("[data-submit-tooltip]")
      .parent()
      .removeClass("isVisible")
      .find("[data-content-tooltip]")
      .fadeOut();
    $("[data-submit-tooltip]").attr("aria-expanded", "false");
  });

  $(".pageInfoBar__condition").on("keydown", function (e) {
    if (e.keyCode === 27) {
      if ($(".pageInfoBar__condition").hasClass("isVisible")) {
        $(this)
          .removeClass("isVisible")
          .find("[data-content-tooltip]")
          .fadeOut();
        $("[data-submit-tooltip]").attr("aria-expanded", "false");
      }
    }
  });

  // Set equal height - tile list
  if ($(window).width() > 767) {
    if ($(".linkBox__list").length > 0) {
      var maxHeight = -1;

      $(".linkBox__list li").each(function () {
        var tileHeight = $(this).height();
        maxHeight = tileHeight > maxHeight ? tileHeight : maxHeight;
      });

      $(".linkBox__list .lnkBlock").css("height", maxHeight);
    }
  }

  toggleShowSublist();

  if ($("[data-quality-show-status]").length > 0) {
    // problem zdublowanych id co powoduje błąd w obsłudze zdarzeń w js oraz nieprawidłową strukturę html (elementy z takim samym id), powód błędu: box jest ładowany z macros w dwoch miejscach na jednej stronie - w aside (desktop) oraz normalnej sekcji (tabletmobile)
    //ponadto problem z kodem html boxu c-qualityBox, który jest zaciagany z różnych źródeł - czasem z makro czasem z innego twiga na różnych proxy, zamiast zmieniac w wielu miejscach jego stukturę, co rzutuje wtedy na style, problem został naprawiony z poziomu js
    // błąd identycznych id jeśli się pojawi, zostanie naprawiony z poziomu js
    const qualityTipsCollection = $('[id^="boxQualityTip"]');
    const manyQualityTips = qualityTipsCollection.length > 1;
    if (manyQualityTips) {
      qualityTipsCollection.each(function (i) {
        $(this).attr("id", `boxQualityTip${i}`);
      });
    }
    let activeQualityBox = $("#boxQualityTip");
    $("[data-quality-show-status]").click(function (e) {
      e.preventDefault();
      const activeParentBox = $(this).closest(".c-qualityBox");
      const activeContentToBeExpanded = activeParentBox.find(
        ".recommended__content"
      );
      activeContentToBeExpanded.addClass("expanded");
      if (manyQualityTips) {
        activeQualityBox = activeParentBox.find('[id^="boxQualityTip"]');
      }
      activeQualityBox.toggleClass("visible").fadeToggle();

      if (activeQualityBox.hasClass("visible")) {
        $("body").click(function (e) {
          if ($(e.target).attr("id") !== "boxQualityTip") {
            activeQualityBox.removeClass("visible").fadeOut(300);
          }
        });
      }

      return false;
    });

    $("[data-quality-close]").click(function () {
      if (manyQualityTips) {
        const activeParentBox = $(this).closest(".c-qualityBox");
        activeQualityBox = activeParentBox.find('[id^="boxQualityTip"]');
      }
      activeQualityBox.removeClass("visible").fadeOut(300);
    });
  }

  ifUseIE();

  $("[data-close-ie-modal]").on("click", function () {
    $(".e-ieBox").remove();
  });

  const relatedLength = $(window).width() > 767 ? 3 : 1;

  Splide.defaults = {
    i18n: {
      prev: "Poprzedni slajd",
      next: "Następny slajd",
      pageX: "Strona %s",
    },
  };




  if ($(".eventWroList:not(.consultation)").length > 0) {
    // this.slider = new Splide(".eventWroList", {
    //   perPage: 8,
    //   perMove: 8,
    //   pagination: false,
    //   gap: "20px",
    //   interval: 3000,
    //   breakpoints: {
    //     2499: {
    //       perPage: 7,
    //       perMove: 7,
    //     },
    //     1920: {
    //       perPage: 6,
    //       perMove: 6,
    //     },
    //     1720: {
    //       perPage: 5,
    //       perMove: 5,
    //     },
    //     1449: {
    //       perPage: 4,
    //       perMove: 4,
    //     },
    //     768: {
    //       perPage: 3,
    //       perMove: 3,
    //     },
    //     629: {
    //       perPage: 2,
    //       perMove: 1,
    //       padding: {
    //         right: 80,
    //       },
    //     },
    //     480: {
    //       padding: {
    //         right: 100,
    //       },
    //     },
    //     450: {
    //       padding: {
    //         right: 60,
    //       },
    //     },
    //     380: {
    //       padding: {
    //         right: 40,
    //       },
    //     },
    //   },
    //   i18n: {
    //     prev: "Poprzednie wydarzenia",
    //     next: "Następne wydarzenia",
    //     // pageX:  'Strona %s',
    //   },
    // }).mount();
  } else if ($(".eventWroList.consultation").length > 0) {
    this.slider = new Splide(".eventWroList", {
      perPage: 7,
      perMove: 7,
      pagination: false,
      gap: "20px",
      interval: 3000,
      breakpoints: {
        2499: {
          perPage: 6,
          perMove: 6,
        },
        1999: {
          perPage: 5,
          perMove: 5,
        },
        1699: {
          perPage: 4,
          perMove: 4,
        },
        1449: {
          perPage: 4,
          perMove: 4,
        },
        1149: {
          perPage: 3,
          perMove: 3,
        },
        890: {
          perPage: 2,
          perMove: 2,
        },
        629: {
          perPage: 1,
          perMove: 1,
          padding: {
            right: 80,
          },
        },
      },
      i18n: {
        prev: "Poprzednie wydarzenia",
        next: "Następne wydarzenia",
        // pageX:  'Strona %s',
      },
    }).mount();
  }




  if ($("[data-related-slider-list] > li").length > relatedLength) {
    if ($(window).width() > 767) {
      const sliders = $("[data-related-slider]");
      
      sliders.each(function (i) {
        $(this).attr("id", `slider${i}`);
        new Splide(`#slider${i}`, {
          perPage: 3,
          perMove: 1,
          pagination: false,
          gap: "20px",
          interval: 3000,
          breakpoints: {
            640: {
              perPage: 2,
            },
          },
        }).mount({
          SlideNumber,
        });
      });
    }

    // bbcode w artykule
    if ($(window).width() < 768) {
      const sliders = $(".relatedBBcode [data-related-slider]");
      sliders.each(function (i) {
        $(this).attr("id", `slider${i}`);
        new Splide(`#slider${i}`, {
          perPage: 2,
          perMove: 2,
          pagination: false,
          gap: "20px",
          interval: 3000,
          breakpoints: {
            575: {
              perPage: 1,
              perMove: 1,
              // arrows: false,
              padding: {
                right: 80,
              },
            },
          },
        }).mount({
          SlideNumber,
        });
      });
    }
  }

  if ($(window).width() > 767) {
    // Related bbCodes
    if ($("[data-related-articles-slider-list] > li").length > relatedLength) {
      const splideArticleProjects = new Splide(
        "[data-related-articles-slider]",
        {
          perPage: 3,
          perMove: 3,
          pagination: false,
          gap: "20px",
          interval: 3000,
          breakpoints: {
            639: {
              perPage: 2,
            },
            575: {
              perPage: 1,
              perMove: 1,
              arrows: false,
              padding: {
                right: 80,
              },
            },
          },
        }
      ).mount({
        SlideNumber,
      });
    }
  }

  // See also bbCodes
  if ($(window).width() > 767) {
    if ($("[data-see-also-article-slider]").length > 0) {
      const seeAlsoLength = $(window).width() > 767 ? 3 : 1;

      $("[data-see-also-article-slider]").each(function () {
        if ($(this).find("li").length > seeAlsoLength) {
          var sliderId = $(this).attr("id");
          new Splide("#" + sliderId, {
            perPage: 3,
            perMove: 3,
            pagination: false,
            gap: "60px",
            interval: 3000,
            breakpoints: {
              1199: {
                gap: "30px",
              },
              991: {
                perPage: 2,
                perMove: 2,
              },
            },
          }).mount();
        }
      });
    }
  }

  // Slider pox powodz 1997
  if ($(window).width() < 992 && $("[data-flood-splide]").length > 0) {
    const floodSplide = new Splide("[data-flood-splide]", {
      perPage: 2,
      perMove: 2,
      pagination: false,
      wheel: true,
      releaseWheel: 300,
      arrows: false,
      padding: {
        right: 70,
      },
      gap: "30px",
      interval: 3000,
      breakpoints: {
        768: {
          perPage: 1,
          perMove: 1,
        },
        // 400: {
        //   perPage: 1,
        //   perMove: 1,
        //   padding: {
        //     right: 60,
        //   },
        // },
      },
    }).mount();
  }

  $("[data-more-item]").on("click", function (e) {
    e.preventDefault();
    const boxWrapper = $(this).closest("[data-info-wrapper]");

    if (boxWrapper.hasClass("expanded")) {
      boxWrapper.removeClass("expanded");
      $(this).attr("aria-expanded", "false");
      $(this).find("[data-change-txt]").text("Rozwiń");
      boxWrapper.find("[data-li]").each(function (i) {
        if (i >= 3) $(this).addClass("hideMobile");
      });
    } else {
      boxWrapper
        .addClass("expanded")
        .find("[data-li]")
        .removeClass("hideMobile");
      $(this).attr("aria-expanded", "true");
      $(this).find("[data-change-txt]").text("Zwiń");
    }
  });

  // js globalna obsługa audioPlayera audioPlayerItem
  if ($("[data-info-link-player]").length > 0) {
    // reusable due to atrr and classes: data-info-link-player, audioPlayerItem added to the same tag - div, button, a etc
    let isAudioPlaying = false;
    let isAudioCreated = false;
    let audio = null;
    const playerGroup = document.querySelectorAll("[data-info-link-player]");
    const audioPath = playerGroup[0].dataset.infoLinkPlayer;

    playerGroup.forEach(function (player) {
      player.addEventListener("click", (e) => {
        if (!isAudioCreated) {
          createAudio();
          isAudioCreated = true;
        }
        setActivePlayer(e, player);
        handlePlayer();
      });
    });

    function createAudio() {
      audio = new Audio(audioPath); // siempre 1 obiekt niezaleznie w ktorego playera klikamy
      audio.addEventListener("ended", changePlayerIcon);
      $(audio).on("timeupdate", function () {
        let percentAudio = (this.currentTime / this.duration) * 100;
        $(".audioRound").attr("percent", percentAudio);
        progressAnimationPlayer();
      });
    }

    function setActivePlayer(event, player) {
      event.preventDefault();
      player.classList.remove("activePlayer");
      const clickedElement = event.target;
      const clickedAudioPlayer = clickedElement.closest(".audioPlayerItem");
      clickedAudioPlayer.classList.add("activePlayer");
    }

    function handlePlayer() {
      changePlayerIcon();
      audioState();
    }

    function changePlayerIcon() {
      const activePlayer = $(".audioPlayerItem.activePlayer");
      let svgPlay = activePlayer.find("svg.player");
      let svgPause = activePlayer.find("svg.pause");
      svgPlay.remove();
      svgPause.remove();
      if (activePlayer.hasClass("playing")) {
        isAudioPlaying = false;
        activePlayer.removeClass("playing");
        activePlayer.append(
          `<svg class="player audioPlayerGroup" width="18" height="40" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"><g class="audioPlayerGroup" id="Warstwa_3"><path class="audioPlayerGroup" d="M13.0596 7.97552L0.933212 14.9767L0.933212 0.974359L13.0596 7.97552Z" fill="#57585B"></path></g></svg>`
        );
      } else {
        isAudioPlaying = true;
        activePlayer.addClass("playing");
        activePlayer.append(
          `<svg class="pause audioPlayerGroup" width="22" height="40" viewBox="0 0 512 512"><g class="audioPlayerGroup"><path class="audioPlayerGroup" d="M224,435.8V76.1c0-6.7-5.4-12.1-12.2-12.1h-71.6c-6.8,0-12.2,5.4-12.2,12.1v359.7c0,6.7,5.4,12.2,12.2,12.2h71.6   C218.6,448,224,442.6,224,435.8z"></path><path class="audioPlayerGroup" d="M371.8,64h-71.6c-6.7,0-12.2,5.4-12.2,12.1v359.7c0,6.7,5.4,12.2,12.2,12.2h71.6c6.7,0,12.2-5.4,12.2-12.2V76.1   C384,69.4,378.6,64,371.8,64z"></path></g></svg>`
        );
      }
    }

    function audioState() {
      switch (isAudioPlaying) {
        case true:
          audio.play();
          break;
        case false:
          audio.pause();
          break;
      }
    }

    // obsługa animacji progress bar na audioplayerze
    function progressAnimationPlayer() {
      $(".audioRound").each(function () {
        let $round = $(this),
          // roundRadius = $round.find('circle').attr('r'),
          roundRadius = 48,
          roundPercent = $round.attr("percent"),
          roundCircum = 2 * roundRadius * Math.PI,
          roundDraw = (roundPercent * roundCircum) / 100;
        $round.css("stroke-dasharray", roundDraw + " 999");
      });
    }
  }
});

// // Slider 'polecamy' go-wro
document.addEventListener("DOMContentLoaded", function() {
  $('[data-slider-loader]').each(function() {
    $(this).addClass('hidden');
  });

  $("[data-related-events]").each(function () {
    var sliderId = $(this).attr("id");
    new Splide("#" + sliderId, {
      perPage: 4,
      perMove: 4,
      arrows: true,
      pagination: true,
      gap: "20px",
      interval: 3000,
      breakpoints: {
        991: {
          perPage: 3,
          perMove: 3,
        },
        767: {
          pagination: false,
          perPage: 2,
          perMove: 2,
        },
        575: {
          pagination: false,
          perPage: 1,
          perMove: 1,
          padding: {
            right: 80,
          },
        },
      },
    }).mount({
      SlideNumber,
    });
  });

  $("[data-related-events-poster]").each(function () {
    var sliderId = $(this).attr("id");
    new Splide("#" + sliderId, {
      perPage: 5,
      perMove: 5,
      arrows: true,
      pagination: true,
      gap: "20px",
      interval: 3000,
      breakpoints: {
        1199: {
          perPage: 4,
          perMove: 4,
        },
        991: {
          perPage: 3,
          perMove: 3,
        },
        768: {
          perPage: 3,
          perMove: 3,
          pagination: false,
        },
        629: {
          perPage: 2,
          perMove: 1,
          padding: {
            right: 80,
          },
        },
        480: {
          padding: {
            right: 100,
          },
        },
        450: {
          padding: {
            right: 60,
          },
        },
        380: {
          perPage: 1,
          perMove: 1,
          padding: {
            right: 40,
          },
        },
      },
    }).mount({
      SlideNumber,
    });
  });
});


function SlideNumber(Splide, Components) {
  const { track } = Components.Elements;

  let elm;

  function mount() {
    elm = document.createElement("div");
    elm.className = "slideNumber";

    track.parentElement.insertBefore(elm, track.nextSibling);

    update();
    Splide.on("move", update);
  }

  function update() {
    elm.textContent = `${Splide.index + 1}/${Splide.length}`;
  }

  return {
    mount,
  };
}

// Scroll to element
function scrollToObj($obj, $offset, $time) {
  if ($.isNumeric($obj)) {
    return;
  }
  if ($(window).width() > 767) {
    $("html, body").animate(
      {
        scrollTop: $obj.offset().top - 60 - $offset,
      },
      $time
    );
  } else {
    $("html, body").animate(
      {
        scrollTop: $obj.offset().top - 50 - $offset,
      },
      $time
    );
  }
}

// Add lnk fancybox to img in single post
function fancyboxLink($obj, $val) {
  $obj.each(function () {
    $(this).attr("data-fancybox", $val);
  });
}

// Remove white space function
function removeWhiteSpaces($obj) {
  $obj
    .filter(function () {
      return this.innerHTML.replace("&nbsp;", " ").trim() == "";
    })
    .remove();
}

// Slide toggle sublist
function toggleShowSublist() {
  $("[data-expanded-button]").click(function () {
    if ($(this).parent().hasClass("expanded")) {
      collapseList($(this));
    } else {
      collapseList($("[data-expanded-button]"));
      $(this).parent().addClass("expanded").find("ul").slideDown();
    }
  });
}

function collapseList($obj) {
  $obj.parent().removeClass("expanded").find("ul").slideUp();
}

// Check if user use IE browser
function ifUseIE() {
  var isIE = "__IE_DEVTOOLBAR_CONSOLE_EVAL_ERROR" in document;

  var infoBox = `<div class="e-ieBox">
        <div class="ieModalInfo">
            <button 
            type="button" 
            data-close-ie-modal 
            aria-label="Wyłącz okno powiadomienia">
            </button>
            <p class="ieModalInfo__title">Twoja przeglądarka jest nieaktualna!</p>
            <p>Może to powodować kłopoty z bezpieczeństwem oraz nieprawidłowe wyświetlanie stron.</p>
        </div>
    </div>`;

  if (isIE) {
    $("body").prepend($(infoBox));
  }
}

function checkIfCookieConsent() {
  document.addEventListener("click", (e) => {
    const cookieButtonId = e.target.id;
    switch (cookieButtonId) {
      case "cky-btn-accept":
        localStorage.setItem("cookieAccepted", "yes");
        $(".searchPopup__searchArea").removeClass("hidden");
        break;
      case "cky-btn-reject":
        localStorage.setItem("cookieAccepted", "no");
        break;
    }
  });
}

/* ----------------------------------  Show element on scroll page ---------------------------------- */
function showElementOnScroll(el) {
  $(window).on("scroll", function () {
    if ($(window).width() > 768) {
      if ($(window).scrollTop() > 700) {
        el.addClass("show");
      } else {
        el.removeClass("show");
      }
    }

    if ($(window).width() < 768) {
      if ($(window).scrollTop() > 250) {
        el.addClass("show");
      } else {
        el.removeClass("show");
      }

      // uniesienie chatbota
      if (el.hasClass("show")) {
        $(".kodabots-promo-4gHwe12").addClass("moveUp");
        $(".kodabots-widget-animated-4gHwe12").addClass("moveUp");
      } else {
        $(".kodabots-promo-4gHwe12").removeClass("moveUp");
        $(".kodabots-widget-animated-4gHwe12").removeClass("moveUp");
      }

      if (
        $(window).scrollTop() >
        $(".mainFooter").offset().top - $(window).height()
      ) {
        el.removeClass("show");
      }
    }
  });
}

/* ----------------------------------  Back to homepage button ---------------------------------- */
showElementOnScroll($(".backToHomepage"));
showElementOnScroll($(".wboBelkaCover"));
/* ----------------------------------  Bottom sticky bar ---------------------------------- */
showElementOnScroll($("#bottomStickyBar"));

/* ---------------- SHOW OR HIDE CONTENT ON CLICK -------------------- */
function showHideContent() {
  $("[data-showhide-btn]").on("click", function (e) {
    e.preventDefault();

    const contentWrapper = $("[data-showhide-content]");

    if (contentWrapper.hasClass("expanded")) {
      contentWrapper.removeClass("expanded");
      $(this).text("Zobacz zalecenia");
      $(this).removeClass("showHideBtn");
    } else {
      contentWrapper.addClass("expanded");
      $(this).addClass("showHideBtn");
      $(this).text("Ukryj zalecenia");
    }
  });
}

// _____________________________________ prezydent
if ($("[data-anchor-prez]").length > 0) {
  let titleBoxes = document.querySelectorAll(".pointers__groupTitleBox");
  let anchorTitles = document.querySelectorAll(".pointers__anchor");
  const pointers = document.querySelector(".pointers");
  let lastScroll = 0;
  let scrollDown = true;

  const windowHeight = window.innerHeight;
  const correctedWindowHeight = windowHeight + 130 - windowHeight;

  window.addEventListener("scroll", function () {
    makeStickyAnchors();
    let actualScroll = window.pageYOffset || document.documentElement.scrollTop;
    if (actualScroll < lastScroll) {
      scrollDown = false;
    } else {
      scrollDown = true;
    }
    lastScroll = actualScroll <= 0 ? 0 : actualScroll;
    titleBoxes.forEach(findActiveAnchor);
  });

  function makeStickyAnchors() {
    if (
      $(window).scrollTop() >=
      $("[data-page-info-bar]").outerHeight() +
        $("[data-logo-bar]").outerHeight() +
        $(".mainHeader").outerHeight() +
        $(".c-breadcrumb").outerHeight() +
        $(".c-header").outerHeight()
    ) {
      pointers.classList.add("stickyPointers");
    } else {
      pointers.classList.remove("stickyPointers");
    }
  }
  function findActiveAnchor(titlebox, index) {
    const bounding = titlebox.getBoundingClientRect();
    let elementTop = bounding.top;
    if (scrollDown && elementTop <= correctedWindowHeight) {
      anchorTitles.forEach((anchor) => anchor.classList.remove("activeAnchor"));
      anchorTitles[index].classList.add("activeAnchor");
    } else if (!scrollDown && elementTop <= windowHeight) {
      anchorTitles.forEach((anchor) => anchor.classList.remove("activeAnchor"));
      anchorTitles[index].classList.add("activeAnchor");
    }
  }
  scrollToAnchorGroup();
  function scrollToAnchorGroup() {
    $("[data-anchor-prez] li").click(function (e) {
      e.preventDefault();
      $(".pointers__anchor").removeClass("activeAnchor");
      $(this).addClass("activeAnchor");
      let itemId = $(this).data("id");
      $("html, body").animate(
        {
          scrollTop: $(itemId).offset().top - 138,
        },
        300
      );
    });
  }
}

/* ----------------------------------  Dropdown Pointers ---------------------------------- */
$(function () {
  $(".infoBox .dropdownHeader").click(function () {
    var box = $(this).closest(".infoBox");

    if (box.hasClass("expanded")) {
      box.removeClass("expanded").find(".dropdownBody").stop().slideUp();
    } else {
      $(".infoBox")
        .closest(".infoBox")
        .removeClass("expanded")
        .find(".dropdownBody")
        .stop()
        .slideUp();
      box.addClass("expanded").find(".dropdownBody").stop().slideDown();

      $("body").click(function (e) {
        if ($(e.target).attr("class") !== "infoBox") {
          $(".infoBox.expanded")
            .removeClass("expanded")
            .find(".dropdownBody")
            .stop()
            .slideUp();
        }
      });
    }
    return false;
  });

  //slider calendar
  if ($("[data-calendar]").length > 0) {
    // console.log('sss')
    new Splide("[data-calendar-slider]", {
      perPage: 7,
      perMove: 7,
      // pagination : false,
      gap: "30px",
      interval: 3000,
      breakpoints: {
        2499: {
          perPage: 6,
          perMove: 6,
        },
        1999: {
          perPage: 5,
          perMove: 5,
        },
        1699: {
          perPage: 4,
          perMove: 4,
        },
        1449: {
          perPage: 4,
          perMove: 4,
        },
        1200: {
          perPage: 3,
          perMove: 3,
        },
        890: {
          perPage: 2,
          perMove: 2,
          gap: "20px",
        },
        629: {
          perPage: 1,
          perMove: 1,
          gap: "15px",
          padding: {
            right: 80,
          },
        },
      },
      i18n: {
        prev: "Poprzednie wydarzenia",
        next: "Następne wydarzenia",
        // pageX:  'Strona %s',
      },
    }).mount();
  }
});

/* ---------------- TRAP FOCUS INSIDE MODAL --------------------------------------- */
function trapFocus($modalName) {
  // add all the elements inside modal which you want to make focusable
  const focusableElements =
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
  const modal = document.querySelector($modalName); // select the modal by it's id
  let firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
  let focusableContent = modal.querySelectorAll(focusableElements);
  let lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
  document.addEventListener("keydown", function (e) {
    firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
    focusableContent = modal.querySelectorAll(focusableElements);
    lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
    let isTabPressed = e.key === "Tab" || e.keyCode === 9;
    if (!isTabPressed) {
      return;
    }
    if (e.shiftKey) {
      // if shift key pressed for shift + tab combination
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus(); // add focus for the last focusable element
        e.preventDefault();
      }
    } else {
      // if tab key is pressed
      if (document.activeElement === lastFocusableElement) {
        // if focused has reached to last focusable element then focus first focusable element after pressing tab
        firstFocusableElement.focus(); // add focus for the first focusable element
        e.preventDefault();
      }
    }
  });

  firstFocusableElement.focus();
}

// Dodaj atrybut do elementów
function setAttribute($element, $attr, $val) {
  window.addEventListener("load", () => {
    const list = document.querySelectorAll($element);

    list.forEach((element) => {
      element.setAttribute($attr, $val);
    });
  });
}

// bb jakosć powietrza
$(function () {

  $('[data-show-quality-button]').click(function(e){
      e.preventDefault();

      $('#boxQualityTip, .boxOverlay').toggleClass('visible').fadeToggle();

      if ($('#boxQualityTip').hasClass('visible')) {
        $('body').click(function(e) {
          if($(e.target).attr('id') !== 'boxQualityTip') {
            $('#boxQualityTip, .boxOverlay').removeClass('visible').fadeOut(300);
          }
        });
      }  

      return false;
  });
}); 

/* window.onload = () => {
	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				//console.log(entry.target.dataset.src)
				entry.target.src = entry.target.dataset.src
				observer.unobserve(entry.target)
			}
		})
	}, { threshold: 0.5 })
	document.querySelectorAll('img[data-src]').forEach(img => observer.observe(img))
} */

// KOCIA PIĘKNOŚĆ GALERIA W ARTYKULE
$(function () {
  // ZAWSZE POKAZUJE PIERWSZE 9 FOTEK
  if ($("#loadMoreScroll .gallery-cover-item").length > 0) {
    $("#loadMoreScroll .gallery-cover-item").each(function (index) {
      var num = (index + 1) % 1000;
      if (num <= 9 && num > 0) {
        $(this).removeClass("isHidden");
      }
      console.log($(this));
    });
  }

  // LAPIE ZDARZENIE SCROLL I ŁADUJE PACZKI PO 9FOTEK
  if ($("#loadMoreScroll").length > 0) {
    var loction_galery_top =
      $("#loadMoreScroll").offset().top - window.innerHeight / 2;
    var counter = 0;
    var shift = 0;
    const fewPhoto = document.querySelectorAll("div.gallery-cover-item");

    $(window).scroll(function () {
      var loction_galery = loction_galery_top + shift;

      console.log(loction_galery, "loction_galery");

      if ($(this).scrollTop() > loction_galery) {
        console.log($(this).scrollTop(), "scrollTop");

        for (let i = 0; i < fewPhoto.length; i++) {
          const onePhoto = fewPhoto[i];

          if (counter >= 9) {
            shift = shift + window.innerHeight / 2;
            counter = 0;
            /* console.log('break');
            console.log(counter, 'counter');
            console.log(shift, 'shift'); */
            break;
          }
          if (onePhoto.classList.contains("isHidden")) {
            onePhoto.classList.remove("isHidden"); //.fadeIn();
            counter++;
            /* console.log('isHidden');
            console.log(counter, 'counter'); */
          }
        }
      }
    });
  }
});

// STRONA TAGOW TAGS
/* $(function () {
  var cTagsList = $('.c-tags #c-tagsList');
  var threeTagHeight = cTagsList.find('li').height() * 2 + 60;

  if (cTagsList.height() > threeTagHeight) {
    cTagsList.addClass('hide').height(threeTagHeight);
  } else {
    $('#showMoreTags').hide();
  }

  var listItems = document.querySelectorAll('.c-tags #c-tagsList li');
  var listHeight = threeTagHeight;

  var count = 0;for (var i = 0; i < listItems.length; i++) {
    if (listItems[i].offsetTop + listItems[i].offsetHeight > listHeight) {
      count++;
    }
  }

  if (count > 0) {
    for (var i = listItems.length - 1; i >= 0; i--) {
      if (listItems[i].offsetTop + listItems[i].offsetHeight > listHeight) {
        listItems[i].style.display = 'none';
      }
    }
  }

  $('#showMoreTags').click(function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
    cTagsList.removeClass('expanded');

    if ($(this).hasClass('active')) {
      cTagsList.addClass('expanded').removeClass('hide').css('height', 'auto');
      if (count > 0) {
        for (var i = listItems.length - 1; i >= 0; i--) {
            listItems[i].style.display = 'inline-block';          
        }
      }
      $(this).text('Pokaż mniej');
    } else {
      cTagsList.removeClass('expanded').addClass('hide').height(threeTagHeight);
      if (count > 0) {
        for (var i = listItems.length - 1; i >= 0; i--) {
          if (listItems[i].offsetTop + listItems[i].offsetHeight > listHeight) {
            listItems[i].style.display = 'none';
          }
        }
      }
      $(this).text('ZOBACZ WSZYSTKIE');
    }
  });
}); */

$(function () {
  var cTagsList = $(".c-tags #c-tagsList");
  var threeTagHeight = cTagsList.find("li").height() * 2 + 60;

  if (cTagsList.height() > threeTagHeight) {
    cTagsList.addClass("hide").height(threeTagHeight);
  } else {
    $("#showMoreTags").hide();
    $(".c-tags #c-tagsList").removeClass("hide");
  }

  var listItems = document.querySelectorAll(".c-tags #c-tagsList li");
  var listHeight = threeTagHeight;

  for (var i = 0; i < listItems.length; i++) {
    if (listItems[i].offsetTop + listItems[i].offsetHeight > listHeight) {
      $(listItems[i]).addClass("hidden");
    }
  }

  $("#showMoreTags").click(function (e) {
    e.preventDefault();
    $(this).toggleClass("active");
    cTagsList.removeClass("expanded");

    if ($(this).hasClass("active")) {
      cTagsList.addClass("expanded").removeClass("hide").css("height", "auto");
      $(listItems).removeClass("hidden");
      $(this).text("Pokaż mniej");
    } else {
      cTagsList.removeClass("expanded").addClass("hide").height(threeTagHeight);
      $(listItems).each(function (index, item) {
        if (item.offsetTop + item.offsetHeight > listHeight) {
          $(item).addClass("hidden");
        }
      });
      $(this).text("Zobacz wszystkie");
    }
  });
});

const dictionary = {
  offerHints: "WYDARZENIA",
  placeHints: "WYDARZENIA W MIEJSCACH",
  categoryHints: "KATEGORIE",
}
// highlight serach string
function highLight(searchText, targetText, tag = 'mark', className="highlight") {
  const regex = new RegExp(searchText, 'gi');
  let text = targetText.replace(/(<mark class="highlight">|<\/mark>)/gim, '');
  return text.replace(regex, '<mark class="highlight">$&</mark>');
}

// plural
class Translator {
    constructor(dictionary) {
      this.pr = new Intl.PluralRules('pl-PL');
      this.dictionary = dictionary;
    }
    translate(i, key) {
      return `${i} ${this.dictionary[key] ? this.dictionary[key][this.pr.select(i)]: key}`
    }
}
const plurals = [];
plurals['result'] = {many: 'wyników', one: 'wynik', few: 'wyniki'};
plurals['event'] = {many: 'wydarzeń', one: 'wydarzenie', few: 'wydarzenia'};

const pluralizer = new Translator(plurals);

const msgNoItems = 'Brak wydarzeń. Spróbuj ponownie.';
const msgShowAllResults = 'Pokaż wszystkie wyniki';

const api = 'https://go.wroclaw.pl/api/v2.0';
const apiHintsAction = 'hints';
const resultsAction = 'wydarzenia';
const resultsParam = 'szukaj';
const apiKey = '264595365153450514637910575663299275034';

document.addEventListener('click', function(event){
  const hints = document.querySelector('#hints');
  const search = document.querySelector('.heroGo__search');
  if(!(hints?.contains(event.target) || search?.contains(event.target))) {
    hints?.remove() && document.querySelector('form.heroGo__searchPanel')?.reset();

  }
});

const delayKeyUp = (() => {
  let timer = null;
  const delay = (func, ms) => {
    timer ? clearTimeout(timer): null
    timer = setTimeout(func, ms)
  }
  return delay
})();

const searchFunc = (e) => {
  e.preventDefault();
  $("#hints").remove();
  const term = e.target.value.trim();
  if ('' === term) return;
  $.ajax({
    method: "GET",
    url: `${api}/${apiHintsAction}/${term}?key=${apiKey}`,
    dataType: "json",
    cache: true,
  }).done(function (oData) {
    const hints = document.createElement('span');
    hints.setAttribute('id', 'hints');
    hints.setAttribute('role', 'tooltip');
    let itemsCount = 0;
    Object.entries(oData).forEach(([key, value]) => {
      if (key.endsWith('Count')) {
        itemsCount += value;
      }
    });
    if (0 === itemsCount) {
      const msg = document.createTextNode(msgNoItems);
      const p = document.createElement('p');
      p.appendChild(msg);
      hints.appendChild(p);
    } else {
      Object.entries(oData).forEach(([key, value]) => {
        if (key.endsWith('Hints')) {
          const hitsCount = oData[key.replace('Hints','Count')];
          // early retun not works
          if (0 !== hitsCount)  {
            const title = document.createTextNode(
                `${dictionary[key] ? dictionary[key] : key} (${pluralizer.translate(hitsCount, 'result')})`);
            const categoryTitle = document.createElement('h3');
            categoryTitle.appendChild(title);

            hints.appendChild(categoryTitle);

            const list = document.createElement('ul');
            Array.isArray(value) && value.map(item => {
              const listItem = document.createElement('li');
              const eventUrl = item.link ? item.link : window.location.href;
              const eventLink = document.createElement('a');
              eventLink.setAttribute('href', eventUrl);
              eventLink.insertAdjacentHTML('beforeend', highLight(oData.query, item.title || item.name || 'Wydarzenie'));
              // add place
              if ('eventPlaceName' in item) {
                const placeNameNode = document.createTextNode(` | ${item.eventPlaceName}`);
                eventLink.appendChild(placeNameNode);
              }
              //add evenferCount
              if ('offerCount' in item || 'eventCount' in item) {
                const count = item.offerCount ? item.offerCount : item.eventCount ? item.eventCount : 0;
                const countNode = document.createTextNode(` (${pluralizer.translate(count, 'event')})`);
                eventLink.appendChild(countNode);
              }
              listItem.appendChild(eventLink);
              list.appendChild(listItem);
            });

            hints.appendChild(list);
          }
        }
      });
    }

    let url = new URL(window.location.href);
    const searchResultsUrl = new URL(`${url.pathname}${'/'!== url.pathname.substr(-1) ? '/' : ''}${resultsAction}`, url);
    searchResultsUrl.searchParams.set(resultsParam, oData.query);
    const allResults = document.createElement('a');
    const allResultsText = document.createTextNode(msgShowAllResults);
    allResults.appendChild(allResultsText);
    allResults.setAttribute('href', searchResultsUrl.toString());
    hints.appendChild(allResults);
    $(".heroGo__searchPanel").after(hints);
    if(itemsCount === 0) {
      $(hints).delay(2500).fadeOut().queue(function(nxt) {
        $(this).remove();
        nxt();
      });
    }
  });
}
$("#goSearch").keyup(
    function (e) {
      //@TODO Zakomentowane w celu wyłączenia hints na keyup, włączyć jak ogarniemy poprawne hints od freama
      return;
});

$( "form.heroGo__searchPanel.redirectResults" ).on( "submit", function( event ) {
  if ($('#goSearch').val().trim() === '') return;
  event.preventDefault();
  $(".goSearchButtonIcon").addClass('button-loader').removeClass('icon-search');
  $("#goSearchButton").prop('disabled', true).prop('value','Szukam');
  const url = new URL(window.location.href);
  const searchResultsUrl = new URL(`${url.pathname}${'/'!== url.pathname.substr(-1) ? '/' : ''}${resultsAction}`, url);
  searchResultsUrl.searchParams.set(resultsParam, document.querySelector('#goSearch').value);
  window.location.replace(searchResultsUrl);
}); 

$( "form.resultsPage").on( "submit", function( event ) {
  if ($('#goSearch').val().trim() === '') {
    event.preventDefault();
  } else {
    $( "form.resultsPage .icon-search" ).removeClass('icon-search').addClass('button-loader');
    $("#resultsSearchButton").prop('disabled', true).prop('value','Szukam');
  }
});


// GoWroclawPl button dodaj wydarzenie / miejscie
$(function () {
  if ($(window).width() > 992) {
    $('.heroGo__addIvent').on('keydown mouseenter mouseleave', function(event) {
      if (event.keyCode === 13 || event.type === 'mouseenter') {
    
        var isExpanded = $(this).find('.heroGo__addIvent--button').attr('aria-expanded') === 'true';
        $(this).find('.heroGo__addIvent--button').attr('aria-expanded', !isExpanded);
    
        var menu = $(this).find('.heroGo__addIvent--menu');
        $(this).addClass('hover');
        $('.heroGo__addIvent.hover')
        .not(this)
        .removeClass('hover')
        .find('.heroGo__addIvent--menu')
        .stop().slideUp();
        menu.stop()
        .slideDown();
      }
    
      if (event.keyCode === 27 || event.type === 'mouseleave') {
        $(this).find('.heroGo__addIvent--button').attr('aria-expanded', 'false');
        $(this).removeClass('hover').find('.heroGo__addIvent--menu').stop().slideUp();
      }
    });
  } else {
    $(".heroGo__addIvent").click(function () {
      $(this)
        .toggleClass("hover")
        .children(".heroGo__addIvent--menu")
        .stop(true, true)
        .slideToggle();
    });
  }
});